import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userToken: localStorage.getItem('userToken') || '',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
        adminToken: localStorage.getItem('adminToken') || ''
    },
    mutations: {
        SET_USER_TOKEN(state, token) {
            state.userToken = token
            localStorage.setItem('userToken', token)
        },
        SET_USER_INFO(state, info) {
            state.userInfo = info
            localStorage.setItem('userInfo', JSON.stringify(info))
        },
        SET_ADMIN_TOKEN(state, token) {
            state.adminToken = token
            localStorage.setItem('adminToken', token)
        },
        LOGOUT(state) {
            state.userToken = ''
            state.userInfo = {}
            localStorage.clear()
        },
        ADMIN_LOGOUT(state) {
            state.adminToken = ''
            localStorage.removeItem('adminToken')
        }
    },
    actions: {
        login({ commit }, form) {
            const token = 'mock-' + Date.now()
            const info = { id: 1, username: form.username, role: form.username === 'admin' ? 'admin' : 'user' }
            commit('SET_USER_TOKEN', token)
            commit('SET_USER_INFO', info)
            return Promise.resolve(true)
        },
        adminLogin({ commit }, form) {
            if (form.username === 'admin' && form.password === '123456') {
                commit('SET_ADMIN_TOKEN', 'admin-' + Date.now())
                return Promise.resolve(true)
            }
            return Promise.resolve(false)
        }
    }
})
